import { app } from '../shared';

export const fetchUserAdverts = async (query = {}) => {
  return app.service('user-adverts').find({ query: query });
};
